module.exports = __webpack_public_path__ + "9b2caa686b14da302d8cb221771bb448.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/train-s.png
// module id = 2565
// module chunks = 0